<template>
  <Modal
      v-model="_value"
      width="700"
      title="绑定车辆"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <!--<Table border :columns="vehicleColumns" :data="bindVehicles" height="500"></Table>-->
    <div style="position:relative;">
      <Table border highlight-row size="small" height="600" :columns="vehicleColumns" :stripe="true" :data="content" ref="table" :height="500"
             @on-sort-change="sortChange" @on-filter-change="filterChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
          style="text-align:right;margin-top:3px;"></Page>
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="车辆">
        <Select
            v-model="selectVehicleInfos"
            multiple
            filterable
            remote
            :remote-method="searchVehicleInfo"
            :loading="searchVehicleInfoLoading">
          <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="index">
            {{option.registrationNum==null?option.vin:option.registrationNum}}
          </Option>
        </Select>
      </Form-item>
    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" @click="onBindVehicleInfos">绑定</Button>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"
  import {registrationColor, registrationTextColor} from '@/libs/registrationutil'

  export default {
    name: 'clientbindvehicleinfomodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
    },
    data() {
      return {
        userId:null,

        totalElements:0,
        content:[],
        pageSize:0,
        listLoadding:false,

        selectVehicleInfos: [],
        searchVehicleInfoLoading: false,
        searchVehicleInfoList:[],

        pageSize:30,
        listLoadding:false,
        pageIndex:1,

        vehicleColumns: [
          {
            title: 'ID',
            key: 'id',
            sortable: 'custom',
            ellipsis: 'true',
            width:120
          },
          {
            title: '车辆名称',
            sortable: 'custom',
            ellipsis: 'true',
            render: (h, params) => {
              let style = {}
              let name = null
              if(params.row.registrationNum){
                name = params.row.registrationNum
                style = {
                  backgroundColor: registrationColor(params.row.registrationColor),
                  color: registrationTextColor(params.row.registrationColor)
                }
              }else{
                name = params.row.vin
              }
              return h('Button', {
                props: {
                    size: 'small',
                },
                style: style
                // , on: {
                //     click: () => {
                //         store.dispatch('VehicleInfoServ_GetDetail', {
                //             params: {id: params.row.id},
                //             urlparams: null
                //         }).then(() => {
                //             this.modifyVehicleInfo = store.getters.get_VehicleInfo_GetDetailResult;
                //             this.modifyVehicleInfoModalValue = true;
                //         }).catch(err => {
                //             this.$Message.error(err);
                //         });
                //
                //     }
                // }
              }, name);
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            ellipsis: 'true',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    disabled: false,
                    size:'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认解绑',
                        content: '<p>确认解绑</p>',
                        onOk: () => {
                          store.dispatch('VehicleInfoServ_UnBindUserVehicleInfos', {
                            params: {
                              userId: this.userId,
                              vehicleInfoIds: [params.row.id]
                            },
                            urlparams: null
                          }).then(() => {
                            this.$Message.success('解绑成功')
                            this.selectVehicleInfos = []
                            this.refreshPage()
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '解绑')
              ]);
            }//render
          }
        ],
      }
    },
    methods: {
      ...mapActions([
        'ClientInfoServ_GetDetail',
        'VehicleInfoServ_GetClientBindVehicleInfosPage',
        'VehicleInfoServ_BindVehicleInfosToUser'
      ]),
      onBindVehicleInfos(){
        store.dispatch('VehicleInfoServ_BindVehicleInfosToUser', {
          params: {userId: this.userId, vehicleInfoIds: this.selectVehicleInfos},
          urlparams: null
        }).then(() => {
          this.$Message.success('绑定成功');
          this.selectVehicleInfos = [];
          this.setPage(1)
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      searchVehicleInfo(input) {
        this.searchVehicleInfoLoading = true
        if (!input || input.length <= 0) {
          this.searchVehicleInfoList = []
          this.searchVehicleInfoLoading = false
        } else {
          store.dispatch('VehicleInfoServ_SearchByName', {
            params: {name: input},
            urlparams: null
          }).then(() => {
            this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
            this.searchVehicleInfoLoading = false
            // console.log(this.searchVehicleInfoList)
          }).catch(err => {
            console.log(err);
            this.searchVehicleInfoLoading = false
          })
        }
      },
      visibleChange(val) {
        if (val) {
          this.userId = this._initValue
          this.setPage(1)
        }
      },
      onSuccess() {
        this.setPage(1)
      },
      onModifySuccess() {
        this.refreshPage()
      },
      onFilterClick() {
        this.setPage(1)
      },
      sortChange({column, key, order}) {
        this.sort = {
          name: key,
          asc: order === 'asc' ? true : false
        }
        this.refreshPage()
      },
      filterChange(){
        this.refreshPage()
      },
      setPage(page) {
        this.pageindex = page;
        this.listLoadding = true;

        let sortParam = null;

        if (this.sort !== null && this.sort !== undefined) {
          sortParam = genSortParam(this.sort.name, this.sort.asc);
        }

        store.dispatch('VehicleInfoServ_GetClientBindVehicleInfosPage', {
          params: {userId:this.userId},
          urlparams: {
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam,
            q: null
          }
        }).then(() => {
          this.totalElements = store.getters.get_VehicleInfo_GetClientBindVehicleInfosPageResult.totalElements
          this.content = store.getters.get_VehicleInfo_GetClientBindVehicleInfosPageResult.content
          this.pageSize = store.getters.get_VehicleInfo_GetClientBindVehicleInfosPageResult.size
          this.listLoadding = false
        }).catch(err => {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      //刷新当前页
      refreshPage() {
        this.setPage(this.pageindex)
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>

